import String_ from './String.vue';
import Multiple from './Multiple.vue';
import Unique from './Unique.vue';
import Number_ from './Number.vue';
import Ranking_ from './Ranking.vue';
import Slider_ from './Slider.vue';

export const Components = {
	String_,
	Multiple,
	Unique,
	Number_,
	Ranking_,
	Slider_
}